import React, { useState } from 'react'
import Input from './Form Elements/Input'
import Button from '../ui/Button'
import { useNavigate } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import { apiClient } from '../helpers/Axios'
import toast from 'react-hot-toast'
import Wrapper from '../helpers/Wrapper'

function ResetPasswordContainer() {

    const navigate = useNavigate()
    const [email, setEmail] = useState("")

    // Login
    const { isPending, mutate } = useMutation({
        mutationFn: async (email) => {
            return apiClient.post('/auth/reset', { email });
        },
        onSuccess: () => {
            navigate('/account/login?password-recovery')
        },
        onError: (error) => {
            toast.dismiss()
            toast.error(error?.response?.data || error?.message)
        }
    })

    const handleLogin = () => {
        mutate(email)
    }


    return (
        <Wrapper>
            <div className="w-full space-y-7 mx-auto max-w-xl my-10">
                <h1 className="text-xl lg:text-2xl font-medium">Forgot Password</h1>
                <p className="text-gray-500">
                    Lost your password? Please enter your email address. You will receive a link to create a new password via email.
                </p>
                <div className="flex flex-col gap-5">
                    <Input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                    <Button onClick={handleLogin} fullWidth loading={isPending}>Reset Password</Button>
                </div>
            </div>
        </Wrapper>
    )
}

export default ResetPasswordContainer